<template>
  <div>
    <h4 class="body-1-bold mb-12">
      {{ i18n(translations.shippingFrom) }}
    </h4>
    <RevInputSelect
      id="expeditionCountrySelect"
      v-model="values.expeditionCountry"
      class="mb-12 w-full md:mb-24 md:w-[328px]"
      :error="errors.expeditionCountry"
      :label="i18n(translations.expeditionCountryLabel)"
      :options="expeditionCountryOptions"
    />
    <h4 class="body-1-bold mb-12">
      {{ i18n(translations.taxIdLabel) }}
    </h4>
    <RevInputText
      id="taxIdInput"
      v-model="values.taxIdNumber"
      class="w-full md:w-[328px]"
      :error="errors.taxIdNumber"
      :label="i18n(translations.taxIdHint)"
    />
  </div>
  <div ref="hasEstablishmentInEuAnchor">
    <h4 class="body-1-bold mb-12">
      {{ i18n(translations.euEstablishmentLabel) }}
    </h4>
    <div
      class="mb-16 grid grid-cols-2 gap-8 md:flex md:w-[328px] md:gap-0"
      data-test="euEstablishmentPickers"
    >
      <RevPicker
        class="mr-8 w-[160px] shrink"
        :class="{ 'border-static-danger-hi': errors.hasEstablishmentInEu }"
        :label="i18n(translations.yes)"
        :model-value="values.hasEstablishmentInEu"
        @update:model-value="handleChangeEuEstablishment(true)"
      />
      <RevPicker
        class="w-[160px] shrink"
        :class="{ 'border-static-danger-hi': errors.hasEstablishmentInEu }"
        :label="i18n(translations.no)"
        :model-value="!values.hasEstablishmentInEu"
        @update:model-value="handleChangeEuEstablishment(false)"
      />
    </div>
    <p
      v-if="errors.hasEstablishmentInEu"
      class="body-2 mt-8 flex items-baseline"
      :class="{ 'text-static-danger-hi': errors.hasEstablishmentInEu }"
    >
      {{ errors.hasEstablishmentInEu }}
    </p>
  </div>
  <EuFormFields v-if="values.hasEstablishmentInEu" v-bind="$props" />
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { setFormValues } from '@ds/components/Form/Form.actions'
import { type Option, RevInputSelect } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'
import { RevPicker } from '@ds/components/Picker'

import { scrollIntoView } from '~/utils/scrollIntoView'

import { FORM_IDS } from '../../../../../../../../Profile.constants'
import translations from '../../TaxDetailsModal.translations'
import type { FormTaxKey, FormTaxValues } from '../../TaxDetailsModal.types'
import EuFormFields from '../EuFormFields/EuFormFields.vue'

const FORM_ID = FORM_IDS.EDIT_TAX_DETAILS

const props = defineProps<{
  initialValues: FormTaxValues
  errors: Partial<Record<FormTaxKey, string>>
  expeditionCountryOptions: Option[]
  shouldShowExemptCheckbox: boolean
}>()

const i18n = useI18n()

const hasEstablishmentInEuAnchor = useTemplateRef<HTMLElement>(
  'hasEstablishmentInEuAnchor',
)

const values = computed(() => props.initialValues)

function handleChangeEuEstablishment(hasEstablishmentInEu: boolean) {
  setFormValues(FORM_ID, { hasEstablishmentInEu })
  if (hasEstablishmentInEu) {
    scrollIntoView(hasEstablishmentInEuAnchor)
  }
}
</script>
